import React from 'react'
import { Switch, Route, Link } from 'react-router-dom'

import Breadcrumbs from '@/Layout/Breadcrumbs'
import PageTitle from '@/Layout/PageTitle'
import SearchIndex from '@/pages/Search/SearchIndex'

export default function SearchContainer(props) {
  const crumbs = [
    { to: '/search', name: 'Search' }
  ]

  return <>
    <Breadcrumbs>
      {crumbs.map((crumb, index) => (
        <Link key={`${index}${crumb.name}`} to={crumb.to} className="text-xs sm:text-sm text-gray-500 hover:text-gray-700 dark:text-gray-100">
          {crumb.name}
        </Link>
      ))}
    </Breadcrumbs>
    <PageTitle pagetitle='Search'>{[]}</PageTitle>
    <Switch>
      <Route {...props} path='/search'>
        <SearchIndex />
      </Route>
    </Switch>
  </>
}
